import styled, { css } from "styled-components/macro";
import { Link } from "react-router-dom";

import { colors, space, transition } from "shared/styles/constants";

import { hoverFocus } from "shared/styles/defaults";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

export interface StyledIconButtonProps {
  theme?: ITheme;
  size?: "s" | "m" | "l";
}

const getButtonColor = (
  theme?: ITheme
): { backgroundColor: colors | string; iconColor: colors } => {
  switch (theme) {
    case ITheme.primary:
      return {
        backgroundColor: colors.white,
        iconColor: colors.black,
      };
    case ITheme.tertiary:
      return {
        backgroundColor: colors.black,
        iconColor: colors.white,
      };
    default:
      return {
        backgroundColor: "transparent",
        iconColor: colors.grey4,
      };
  }
};

const StyledIconButtonStyles = css<StyledIconButtonProps>`
  background-color: ${({ theme }) => getButtonColor(theme).backgroundColor};

  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  ${hoverFocus.defaultFocus};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${({ theme }) => hoverFocus.defaultHover(getButtonColor(theme).backgroundColor)}

  ${({ size }) => {
    switch (size) {
      default:
      case "s":
        return css`
          padding: ${space.xxs};
        `;
      case "m":
        return css`
          padding: ${space.xs};
        `;
      case "l":
        return css`
          padding: ${space.s};
        `;
    }
  }}
`;

export const StyledIconButton = styled.button<StyledIconButtonProps>`
  ${StyledIconButtonStyles}
`;

export const StyledIconButtonLink = styled(Link)<StyledIconButtonProps>`
  ${StyledIconButtonStyles}

  svg {
    cursor: pointer;
  }
`;

export const StyledIcon = styled(Icon)<StyledIconButtonProps>`
  color: ${({ theme }) => getButtonColor(theme).iconColor};

  transition: transform ${transition.default};
`;
